module.exports = __webpack_public_path__ + "static/media/instant-booking.f658383c.svg";